import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import {publicBuildUrl} from "../../../config/config";
import Modal from "../../Modal";

const SnavelEmoties = () => (
    <Modal>
        <div>
            <Panel
                title={'Hoe ga ik in gesprek met een kind bij (een vermoeden van) kindermishandeling?'}
                link={'Lees meer'}
                intro={'Wanneer je je zorgen maakt over een kind is het belangrijk om hierover het gespre\n' +
                    'aan te gaan met het kind. Zo’n gesprek kan je helpen om zorgen te onderbouwen of\n' +
                    'weg te nemen. In uitzonderlijke situaties kan er voor gekozen worden om niet met de\n' +
                    'jeugdige in gesprek te gaan. Dat is het geval wanneer daarmee de veiligheid van\n' +
                    'betrokkenen ernstig in het geding is (denk aan seksueel geweld, huwelijksdwang,\n' +
                    'eergerelateerd geweld, loverboy problematiek). Vraag dan advies aan een\n' +
                    'deskundige zoals Veilig Thuis. Soms is het wel mogelijk om samen met een andere\n' +
                    'professional het gesprek aan te gaan. Noteer de redenen om (nog) niet met het kind\n' +
                    'in gesprek te gaan altijd in het dossier.'}
                open={true}
            >
                <p className={'text'}>
                    Wanneer je je zorgen maakt over een kind is het belangrijk om hierover het gesprek
                    aan te gaan met het kind. Zo’n gesprek kan je helpen om zorgen te onderbouwen of
                    weg te nemen. In uitzonderlijke situaties kan er voor gekozen worden om niet met de
                    jeugdige in gesprek te gaan. Dat is het geval wanneer daarmee de veiligheid van
                    betrokkenen ernstig in het geding is (denk aan seksueel geweld, huwelijksdwang,
                    eergerelateerd geweld, loverboy problematiek). Vraag dan advies aan een
                    deskundige zoals Veilig Thuis. Soms is het wel mogelijk om samen met een andere
                    professional het gesprek aan te gaan. Noteer de redenen om (nog) niet met het kind
                    in gesprek te gaan altijd in het dossier.
                </p>

                <h2>Wat maakt het lastig voor kinderen om over een onveilige situatie te praten?</h2>

                <p className={'text'}>
                    Het is voor kinderen niet makkelijk om te praten over een situatie waarin sprake is
                    van Kindermishandeling. Tijdens een gesprek kan het helpend zijn om je hier van
                    bewust te zijn. Je zult hierdoor minder snel geneigd zijn om een oordeel te vormen
                    en kunt beter rekening houden met hoe het kind zich tijdens zo’n gesprek voelt.
                </p>

                <ul>
                    <li>Als je niet beter weet, dan denk je dat het normaal is wat er gebeurt. Vaak herkennen deze
                        kinderen hun situatie niet als kindermishandeling en denken ze dat ze zelf schuld hebben aan de
                        situatie.
                    </li>
                    <li>Kinderen zijn loyaal aan hun ouders en willen daarom niet de reden zijn dat er verkeerd gedacht
                        wordt over hun ouders en kunnen zich schuldig gaan voelen als zij vertellen over hun situatie
                    </li>
                    <li>Kinderen weten vaak niet dat ze hulp kunnen krijgen en op welke manier dit kan</li>
                    <li>Kinderen kunnen bang zijn dat ze niet worden gelooft als ze erover vertellen</li>
                    <li>Kinderen kunnen bang zijn voor de gevolgen als ze erover vertellen en houden het daardoor
                        geheim
                    </li>
                    <li>Kinderen kunnen zich schamen voor de situatie</li>
                    <li>Kinderen die voor hun ouders zorgen in plaats van andersom kunnen zich enorm verantwoordelijk
                        voelen voor de situatie.
                    </li>
                    <li>Kinderen kunnen een eerdere slechte ervaring hebben met vertellen over hun situatie waardoor ze
                        een hoge drempel ervaren om dit nog eens te proberen.
                    </li>
                    <li>Kinderen kunnen het niet goed aangeven door een lichamelijke of verstandelijke beperking.</li>
                </ul>

                <p>Kinderen die onveilig opgroeien hebben te maken met verschillende emoties:</p>

                <h3>Geheimen</h3>
                <p className={'text'}>
                    Uit schaamte en angst doen kinderen die onveilig opgroeien vaak hun uiterste
                    best om het verborgen te houden. Soms wordt er door ouders of anderen
                    expliciete geheimhouding van een kind verwacht, vanuit hun eigen schaamte,
                    schuldgevoel of angst voor de gevolgen als de buitenwereld erachter komt wat er
                    speelt. Kinderen voelen feilloos aan dat het niet de bedoeling is om erover te
                    praten, maar zijn ook vaak gewend dat er dingen zijn waar niet over gesproken
                    wordt. Wat als mensen hun verhaal niet geloven, of raar zullen vinden, hun
                    ouders afkeuren of gaan roddelen over de situatie? Het hebben van een geheim
                    legt veel druk op een kind. Geheimen hebben die je met niemand kan delen, kost
                    energie en staat in verband met lichamelijke klachten, lagere zelfwaardering,
                    neerslachtigheid en eenzaamheid (Frijns 2004). Bovendien werkt het door in
                    andere relaties: in hechte vriendschappen oefenen kinderen en jongeren met
                    vertrouwen en wederkerigheid. Dat is erg moeilijk wanneer je een groot geheim
                    met je meedraagt dat je voortdurend moet verstoppen.
                </p>

                <h3>Schuldgevoelens</h3>
                <p className={'text'}>
                    Kinderen zijn nooit schuldig aan kindermishandeling. Toch hebben veel kinderen
                    wel last van schuldgevoelens. Een kind dat heeft geleerd dat het niets waard is of
                    niet deugt, is geneigd om alle schuld aan zichzelf te wijten. Als je niet precies
                    weet wat het verband is tussen de gebeurtenis of situatie en je eigen gedrag, dan
                    ben je geneigd om schuldgevoelens te vergtoten en je ook schuldig te voelen
                    over zaken die niets met jou te maken hebben.
                </p>

                <h3>Schaamte</h3>
                <p className={'text'}>
                    Er zijn ontelbare dingen waar een kind zich voor kan schamen: een moeder die
                    naar alcohol ruikt, extreem veel troep in huis, goedkope en kapotte kleding, de
                    vele ruzies, het feit dat ze geen smartphone kunnen betalen, een vader die ze
                    nooit zien, een moeder die depressief op de bank ligt, schulden, de politie die
                    laatst op de stoep stond, de lege koelkast, een stiefvader die avances maakt op
                    hun vriendinnen…
                </p>
                <p className={'text'}>
                    Hoe ouder een kind wordt, hoe meer het zich bewust is van het mogelijke oordeel
                    van buitenstaander en hoe meer schaamte dus een rol gaat spelen. Ook tussen
                    ouders en kind is er vaak sprake van schaamte. Een ouder schaamt zich omdat
                    het mis gaat, het kind schaamt zich omdat het zich gekwetst en vernedert voelt.
                    Bij seksueel misbruik komt er vaak ook fysieke schaamte bij: (het lichaam van)
                    het kind heeft blijkbaar seksueel gedrag uitgelokt. Dat lichaam kan daardoor een
                    ‘object’ worden om je voor te schamen. Lichamelijke reacties zorgen voor
                    schaamte en verwarring. Maar ook het bevriezen door angst en daardoor geen
                    tegenstand bieden aan de mishandeling kan schuld- en schaamtegevoelens
                    teweegbrengen.
                </p>

                <h3>Loyaliteit</h3>
                <p className={'text'}>
                    Kinderen zijn loyaal aan hun ouders. Ook al is het thuis vaak niet fijn, het is er in
                    de meeste gevallen niet alleen maar ellendig. Dit is verwarrend voor een kind:
                    enerzijds verlangt hij naar een ouder die beschermend is. Vaak zijn er ook
                    inderdaad momenten waarop de ouder zich beschermend gedraagt. Op andere
                    momenten is een mishandelende ouder juist de bron van angst, tegen wie het
                    kind beschermd wil worden. Dit zorgt voor een innerlijk conflict bij het kind, dat
                    hem alleen maar afhankelijker maakt van zijn ouder. Een kind wil niet dat anderen
                    negatief over zijn ouders gaat denken.
                </p>

                <h3>Parentificatie</h3>
                <p className={'text'}>
                    Wanneer kinderen voor hun ouders gaan zorgen in plaats van andersom, spreken
                    we van parentificatie. Een kind vervult de ouderrol wanneer de ouder dit niet wil of
                    niet kan. Vanuit loyaliteit willen kinderen doorgaans graag aan de verwachtingen
                    van hun ouders voldoen. In het geval van parentificatie gaat dit zo ver, dat ze hun
                    eigen behoeften en grenzen niet leren herkennen en ook niet belangrijk leren
                    vinden.
                </p>

                <h3>Angst</h3>
                <p className={'text'}>
                    Kinderen die te maken hebben met geweld of verwaarlozing, zijn vaak angstiger
                    dan andere kinderen. Allereerst zijn ze bang voor herhaling van geweld. Hierdoor
                    kan het kind heel gespannen zijn. Maar ook andere angsten kunnen meespelen:
                    angst voor ontdekking wat er speelt in de thuissituatie, angst voor wat er gebeurt
                    als het kind erover vertelt, angst voor het oordeel van anderen, angst voor de
                    consequenties voor de ouder.
                </p>

                <h3>Eenzaamheid</h3>
                <p className={'text'}>
                    De grote geheimen en de grote emoties die met kindermishandeling gepaard
                    gaan, maken deze kinderen eenzaam. In veel gevallen is er niemand met wie een
                    kind praat over wat er thuis gebeurt. Veel kinderen blijken te denken dat er
                    niemand is die ze zal begrijpen omdat er niemand is die hetzelfde meemaakt als
                    zij. Voor deze kinderen is het niet vanzelfsprekend dat je iemand kan vertrouwen.
                </p>

                <p className={'quote-source'}>
                    <strong>Bron</strong>: Van Gemert, M. (2019). Praktijkboek: Praten met kinderen over
                    kindermishandeling. Bohn Staflue van Loghum
                </p>
            </Panel>
        </div>
    </Modal>
);


export default SnavelEmoties;
